/* FP ARTICLE V2/V3 — 30/09/2026
   Lecture fluide des articles : sommaire (colonne + mobile), produit recommande dans la colonne, barre et temps de lecture,
   apparition douce des blocs, FAQ en accordeon, apercu produit au survol des liens produit (ordinateur).
   Le produit de la colonne est celui de la barre collante du bas (meme choix, meme prix live). */
(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var fine = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;

  function slug(t, used) {
    var s = (t || '').toLowerCase().replace(/[^a-z0-9À-ɏ]+/g, '-').replace(/^-+|-+$/g, '').slice(0, 60) || 'section';
    var base = s, i = 2;
    while (used[s] || document.getElementById(s)) { s = base + '-' + i++; }
    used[s] = 1;
    return s;
  }
  function esc(t) { return (t || '').replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function money(cents) {
    try {
      var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';
      return new Intl.NumberFormat(document.documentElement.lang || 'en-US', { style: 'currency', currency: cur }).format(cents / 100);
    } catch (e) { return ''; }
  }

  // ---------- FAQ en accordeon : chaque H3 de la section FAQ devient un <details> (contenu toujours dans la page)
  function faqAccordion(rte) {
    var h2s = rte.querySelectorAll('h2');
    var faq = null;
    for (var i = 0; i < h2s.length; i++) { if (/faq|frequently asked/i.test(h2s[i].textContent || '')) { faq = h2s[i]; break; } }
    if (!faq) return;
    var n = faq.nextElementSibling, first = true;
    while (n && n.tagName !== 'H2') {
      if (n.tagName === 'H3' && /related|read next|keep reading/i.test(n.textContent || '')) break;
      if (n.tagName === 'H3') {
        var det = document.createElement('details');
        det.className = 'fp-a2-faq';
        if (first) { det.open = true; first = false; }
        var sum = document.createElement('summary');
        sum.innerHTML = n.innerHTML;
        det.appendChild(sum);
        var body = document.createElement('div');
        body.className = 'fp-a2-faq__a';
        det.appendChild(body);
        var nx = n.nextElementSibling;
        while (nx && nx.tagName !== 'H3' && nx.tagName !== 'H2' && !/related/i.test(nx.textContent.slice(0, 40) || '') ) {
          var move = nx; nx = nx.nextElementSibling; body.appendChild(move);
        }
        n.parentNode.replaceChild(det, n);
        n = det.nextElementSibling;
        continue;
      }
      // structure « div.faq-item » (h3 + reponse dans le meme bloc)
      var h3in = n.querySelector && n.querySelector(':scope > h3');
      if (h3in && !/related/i.test(h3in.textContent || '')) {
        var d2 = document.createElement('details');
        d2.className = 'fp-a2-faq';
        if (first) { d2.open = true; first = false; }
        var s2 = document.createElement('summary'); s2.innerHTML = h3in.innerHTML; d2.appendChild(s2);
        var b2 = document.createElement('div'); b2.className = 'fp-a2-faq__a'; d2.appendChild(b2);
        h3in.remove();
        while (n.firstChild) b2.appendChild(n.firstChild);
        n.parentNode.replaceChild(d2, n);
        n = d2.nextElementSibling;
        continue;
      }
      n = n.nextElementSibling;
    }
  }

  // ---------- Apercu produit au survol d'un lien produit dans le texte (ordinateur uniquement)
  function productPeek(rte) {
    if (!fine) return;
    var cache = {}, card = null, hideT = null, cur = null;
    function ensure() {
      if (card) return card;
      card = document.createElement('div');
      card.className = 'fp-a2-peek';
      card.setAttribute('role', 'tooltip');
      document.body.appendChild(card);
      card.addEventListener('mouseenter', function () { clearTimeout(hideT); });
      card.addEventListener('mouseleave', hide);
      return card;
    }
    function hide() { hideT = setTimeout(function () { if (card) card.classList.remove('is-on'); cur = null; }, 160); }
    function place(a) {
      var r = a.getBoundingClientRect(), w = 280;
      var left = Math.min(window.innerWidth - w - 16, Math.max(16, r.left + r.width / 2 - w / 2));
      var top = r.bottom + 10;
      if (top + 330 > window.innerHeight) top = Math.max(16, r.top - 330);
      card.style.left = left + 'px'; card.style.top = top + 'px';
    }
    function show(a, p) {
      ensure();
      var img = p.featured_image ? p.featured_image.replace(/(\.[a-z]+)(\?|$)/i, '$1$2') : '';
      card.innerHTML = '<a href="' + esc(a.href) + '" class="fp-a2-peek__in">'
        + (img ? '<div class="fp-a2-peek__img"><img src="' + esc(img) + (img.indexOf('?') > -1 ? '&' : '?') + 'width=400" alt=""></div>' : '')
        + '<div class="fp-a2-peek__name">' + esc(p.title) + '</div>'
        + '<div class="fp-a2-peek__row"><span class="fp-a2-peek__price">' + money(p.price) + '</span>'
        + (p.compare_at_price > p.price ? '<s>' + money(p.compare_at_price) + '</s>' : '') + '</div>'
        + '<span class="fp-a2-peek__btn">See the product</span></a>';
      place(a);
      card.classList.add('is-on');
    }
    rte.addEventListener('mouseover', function (e) {
      var a = e.target.closest && e.target.closest('a[href*="/products/"]');
      if (!a || !rte.contains(a) || a.closest('.hb-recommendation-card, .fp-cmp, .fp-guide-box') || a.querySelector('img')) return;
      clearTimeout(hideT);
      if (cur === a) return;
      cur = a;
      var m = a.getAttribute('href').match(/\/products\/([^/?#]+)/);
      if (!m) return;
      var h = m[1];
      if (cache[h]) { show(a, cache[h]); return; }
      fetch((window.Shopify && Shopify.routes && Shopify.routes.root || '/') + 'products/' + h + '.js')
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (p) { if (p) { cache[h] = p; if (cur === a) show(a, p); } })
        .catch(function () {});
    });
    rte.addEventListener('mouseout', function (e) {
      var a = e.target.closest && e.target.closest('a[href*="/products/"]');
      if (a && (!e.relatedTarget || !a.contains(e.relatedTarget))) hide();
    });
  }

  // ---------- Apparition douce des blocs au fil de la lecture
  function reveal(root, rte) {
    if (reduce || !('IntersectionObserver' in window)) return;
    var els = rte.querySelectorAll(':scope > h2, :scope > figure, :scope > table, :scope > .key-takeaway, .hb-recommendation-card, .fp-guide-box, .fp-cmp, figure.fp-a2-fig, :scope > p > img');
    var vh = window.innerHeight;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
    }, { rootMargin: '0px 0px -8% 0px' });
    Array.prototype.forEach.call(els, function (el) {
      if (el.getBoundingClientRect().top < vh) return; // deja visible : rien a animer
      el.classList.add('a2-rv');
      io.observe(el);
    });
  }

  function build() {
    var root = document.querySelector('.fp-a2');
    var rte = root && root.querySelector('.blog-post-content rte-formatter, .blog-post-content');
    if (!root || !rte || root.hasAttribute('data-a2-done')) return;
    root.setAttribute('data-a2-done', '');

    faqAccordion(rte);

    // --- sommaire : les H2 du texte, hors encarts et tableau comparatif
    var used = {}, items = [];
    Array.prototype.forEach.call(rte.querySelectorAll('h2'), function (h) {
      if (h.closest('aside, .fp-cmp, .hb-recommendation-card, .fp-guide-box')) return;
      var t = (h.textContent || '').trim();
      if (t.length < 3 || /^(table of contents|contents|in this (guide|article))/i.test(t)) return;
      if (!h.id) h.id = slug(t, used);
      items.push({ id: h.id, text: t, el: h });
    });
    var list = items.map(function (it) { return '<li><a href="#' + it.id + '">' + esc(it.text) + '</a></li>'; }).join('');

    // sommaire mobile, apres le premier paragraphe
    if (items.length >= 3) {
      var firstP = rte.querySelector('p');
      var det = document.createElement('details');
      det.className = 'fp-a2-toc-m';
      det.innerHTML = '<summary>In this guide</summary><ol>' + list + '</ol>';
      if (firstP && firstP.parentNode) firstP.parentNode.insertBefore(det, firstP.nextSibling);
      det.addEventListener('click', function (e) { if (e.target.closest('a')) det.open = false; });
    }

    // --- colonne laterale
    var rail = root.querySelector('.fp-a2-rail');
    var left = null;
    if (rail) {
      var html = '<div class="fp-a2-rail__inner">';
      if (items.length >= 3) html += '<nav class="fp-a2-rail__toc" aria-label="In this guide"><p class="fp-a2-rail__label">In this guide <span class="fp-a2-left" data-a2-left></span></p><ol>' + list + '</ol></nav>';
      var st = document.querySelector('.fp-sticky-cta__inner');
      if (st) {
        var img = st.querySelector('img');
        var name = st.querySelector('.fp-sticky-cta__name');
        var price = st.querySelector('.fp-sticky-cta__price');
        var rating = st.querySelector('.fp-sticky-cta__rating');
        html += '<a class="fp-a2-pick" href="' + esc((st.getAttribute('href') || '').replace('utm_medium=sticky-cta', 'utm_medium=rail')) + '">'
          + '<div class="fp-a2-pick__img">' + (img ? '<img src="' + esc(img.currentSrc || img.src) + '" alt="' + esc(img.alt || '') + '" loading="lazy">' : '') + '</div>'
          + '<div class="fp-a2-pick__eyebrow">Recommended in this guide</div>'
          + '<div class="fp-a2-pick__name">' + esc(name ? name.textContent.trim() : '') + '</div>'
          + '<div class="fp-a2-pick__meta">' + (price ? '<span class="fp-a2-pick__price">' + esc(price.textContent.trim()) + '</span>' : '') + (rating ? '<span>' + esc(rating.textContent.trim()) + '</span>' : '') + '</div>'
          + '<span class="fp-a2-pick__btn">See the product</span></a>';
      }
      html += '</div>';
      rail.innerHTML = html;
      rail.classList.add('fp-a2-rail--ready');
      left = rail.querySelector('[data-a2-left]');

      // section active dans le sommaire
      var links = rail.querySelectorAll('.fp-a2-rail__toc a');
      if (links.length && 'IntersectionObserver' in window) {
        var map = {};
        Array.prototype.forEach.call(links, function (a) { map[a.getAttribute('href').slice(1)] = a; });
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (e) {
            if (e.isIntersecting) {
              Array.prototype.forEach.call(links, function (a) { a.classList.remove('is-active'); });
              var a = map[e.target.id]; if (a) a.classList.add('is-active');
            }
          });
        }, { rootMargin: '-110px 0px -65% 0px' });
        items.forEach(function (it) { io.observe(it.el); });
      }
    }

    // --- barre de progression + temps restant
    var words = (rte.textContent || '').split(/\s+/).length;
    var metaTxt = ((root.querySelector('.fp-a2-meta') || {}).textContent || '').match(/([0-9]+) *min/);
    var metaMin = metaTxt ? parseInt(metaTxt[1], 10) : 0;
    var totalMin = metaMin > 0 ? metaMin : Math.max(1, Math.round(words / 230));
    var bar = document.createElement('div');
    bar.className = 'fp-a2-progress';
    bar.innerHTML = '<span></span>';
    document.body.appendChild(bar);
    var fill = bar.firstChild, ticking = false, lastLeft = -1;
    function upd() {
      var r = rte.getBoundingClientRect();
      var total = r.height - window.innerHeight * 0.6;
      var pct = total > 0 ? Math.min(100, Math.max(0, (-r.top + window.innerHeight * 0.2) / total * 100)) : 0;
      fill.style.width = pct + '%';
      if (left) {
        var m = Math.ceil(totalMin * (1 - pct / 100));
        if (m !== lastLeft) { lastLeft = m; left.textContent = pct >= 99 ? '· done' : '· ' + m + ' min left'; }
      }
      ticking = false;
    }
    window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(upd); } }, { passive: true });
    upd();

    productPeek(rte);
    // laisser les encarts du theme se placer avant d'animer
    setTimeout(function () { reveal(root, rte); }, 600);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', build);
  else build();
})();
